<template>
	<div class="config-snapshot-card">
		<p class="title">
			车辆配置信息
		</p>

		<div class="config-part">
			<div class="config-item" v-for="item in configMap">
				<div>
					{{ item.label }}
				</div>
				<div>
					{{ item.value }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getPaintName, getWheelName } from '@/views1/IndexPage/filterOptions'

export default {
	name: 'ConfigSnapshotCard',
	props: ['car'],
	data() {
		return {
			configMap: [
				{ label: '车辆座位', value: this.car.basic.seat + '座' },
				{ label: '续航电池', value: this.car.basic.battery_desc },
				{ label: '外观颜色', value: getPaintName(this.car.basic) },
				{ label: '轮圈', value: getWheelName(this.car.basic.wheel) },
				// { label: '内饰', value: this.car.basic.interior_material_desc},
				{ label: '钥匙', value: this.car.basic.keys && this.car.basic.keys.join('+') },

				...(this.car.highlight_config || []).map(({ category, value }) => ({
					label: category,
					value
				}))
			]
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.config-snapshot-card {
	margin-top: 70px;
	.title {
		@include subtitle_1(1.4, 400, false);
		color: #040b29;
		margin-bottom: 30px;
	}

	.config-part {
		&:not(:last-child) {
			border-bottom: 1px solid $border_divider_primary;
		}

		.part-title {
			font-size: 18px;
			line-height: 25px;
			color: $text_primary;
			margin-top: 30px;
			margin-bottom: 30px;
		}

		.config-item {
			margin-bottom: 30px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			> * {
				display: flex;
				align-items: center;
			}

			> :first-child {
				font-size: 14px;
				line-height: 20px;
				color: $text_secondary;
			}

			> :last-child {
				@include subtitle_4(1.5, 400, false);

				color: $text_primary;
			}
		}

		.item-avatar {
			display: inline-block;
			width: 46px;
			height: 46px;
			border-radius: 46px;
			background-size: 100% 100%;
			margin-right: 15px;
		}
	}
}
</style>
